// @flow
const RemotePlayerType: {[type: string]: string} = {
  CHROMECAST: 'chromecast'
};

export {RemotePlayerType};



// WEBPACK FOOTER //
// ./common/cast/remote-player-type.js